import { ButtonBase, Tooltip } from '@mui/material'

import { postStat } from 'api/stats/stats.api'
import { openUrl } from 'helpers/global.helper/global.helper'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import authStore from 'store/auth/auth'
import Icon from 'ui/atoms/Icon/Icon'
import { useAuth } from 'ui/components/AuthContext/AuthContext'
import { useSnapshot } from 'valtio'

import styles from './ExplorerMenu.module.less'

type ExplorerMenuProps = {
  hideLabel?: boolean
}

export default function ExplorerMenu({ hideLabel = false }: ExplorerMenuProps): ReactElement {
  const authSnap = useSnapshot(authStore)
  const dbsToken = authSnap.user?.dbs_api_token
  const serviceType = 'abs_meas'
  const organizationName = authSnap.activeSystem?.organization_name

  const { t } = useTranslation()

  const redirectUrl = `https://data.aurorabysigholm.com/explorer?t=${dbsToken}&includeMetadata=abs_service:${serviceType},organization:${organizationName}`

  const { hasAccess } = useAuth()
  const hasAccessToDbsDataExplorer = hasAccess({ module: 'dbsdataexplorer' })

  if (!hasAccessToDbsDataExplorer) {
    return <></>
  }

  return (
    <div className={styles.ExplorerMenu}>
      <Tooltip
        arrow
        children={
          <ButtonBase
            onClick={() => {
              postStat('dbs_data_explorer', 'click')
              openUrl(redirectUrl)
            }}
            className={styles.ExplorerMenu_Button}
            aria-label={hideLabel ? t('Review data') : undefined}
          >
            <span className={styles.ExplorerMenu_IconGroup}>
              <span className={styles.ExplorerMenu_SearchIcon}>
                <Icon color={'white'} size="medium" icon={'far fa-search'} />
              </span>
              <Icon color={'white'} size="large" icon={'fal fa-chart-bar'} />
            </span>
            {!hideLabel && t('Review data')}
          </ButtonBase>
        }
        title={
          <h4>
            {t(
              'NEWS! Now you have the opportunity to review your own measurement data through the external tool Data by Sigholm (DbS). By pressing this button you will be directed to an external page.'
            )}
          </h4>
        }
      />
    </div>
  )
}
